import ApiService from '@/services/core/api.service'

const VoucherService = {
  async get (query = '') {
    return ApiService.get(`disbursement-head/payment-vouchers?${query}`)
  },

  async post (payload) {
    return ApiService.post('disbursement-head/payment-vouchers', payload)
  },

  async put (payload) {
    return ApiService.put(`disbursement-head/payment-vouchers/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`disbursement-head/payment-vouchers/${payload.id}`)
  }
}

export default VoucherService
